import React, { createContext, useContext, useEffect, useState } from 'react';
import { initializeApp, getApps } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getDatabase, onChildChanged } from 'firebase/database';

const FirebaseContext = createContext(null);

const config = {
  apiKey: "AIzaSyBsoQXeqeUqNsFzggQYheaYFFmPdFRjPgQ",
  authDomain: "c-a-t-job-portal.firebaseapp.com",
  databaseURL: "https://c-a-t-job-portal-default-rtdb.firebaseio.com",
  projectId: "c-a-t-job-portal",
  storageBucket: "c-a-t-job-portal.appspot.com",
  messagingSenderId: "390538795524",
  appId: "1:390538795524:web:7b3fdb4112d97d4a8db351",
  measurementId: "G-VXNCVBRN5Z"
};

export const FirebaseProvider = ({ children }) => {
  const [firebaseApp, setFirebaseApp] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Only initialize if not already initialized
    let app;
    if (!getApps().length) {
      app = initializeApp(config);
    } else {
      app = getApps()[0];
    }
    setFirebaseApp(app);
    const unsubscribe = onAuthStateChanged(getAuth(app), setUser);
    return unsubscribe;
  }, []);

  if (!firebaseApp) return null; // or a loading spinner

  return (
    <FirebaseContext.Provider value={{
      firebaseApp,
      user,
      auth: getAuth(firebaseApp),
      db: getDatabase(firebaseApp)
    }}>
      {children}
    </FirebaseContext.Provider>
  );
};

export const useFirebase = () => useContext(FirebaseContext);
